import * as React from 'react'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { S24IconProps } from '@is24/cosma-ui-icons/build/helper'
import { Styles } from '../../../../@types/types'
import { ScreenName } from '../../../../services/domain/wizardScreens'
import { isWebView } from '../../../../utils/navigation'
import { Section } from 'is24-corecss'

export interface ScreenLayoutProps {
  id: string
  deskTooltip?: ReactElement
  mobileTooltip?: ReactElement
  headline: string
  subLine?: string
  screenName: ScreenName
  headerIcon?: ReactElement<S24IconProps>
  className?: string
  sectionClassName?: string
  children?: React.ReactNode
}

const styles: Styles = {
  tooltip: {
    paddingLeft: 98,
  },
}

export const ScreenLayout: React.FC<ScreenLayoutProps> = ({
  id,
  deskTooltip,
  mobileTooltip,
  headline,
  subLine,
  screenName,
  headerIcon,
  children,
  className,
  sectionClassName,
}) => {
  const { t } = useTranslation()
  const isMobile = isWebView()

  return (
    <Section.Root className={sectionClassName || ''}>
      <Section.Header startElement={headerIcon} className={`${isMobile ? '' : 'desk-seven-twelfths'}`}>
        <Section.Title as={isMobile ? 'h4' : 'h3'}>{t(headline)}</Section.Title>
        {subLine && <Section.Subline>{subLine}</Section.Subline>}
      </Section.Header>
      <Section.Content>
        <div className='grid'>
          <div className={`grid-item ${isMobile ? '' : 'desk-seven-twelfths'}`}>
            <div className={className || ''}>{children}</div>
          </div>
          <div
            id={id}
            className={`grid-item palm-hide lap-hide ${isMobile ? 'desk-hide' : 'desk-five-twelfths'}`}
            style={styles.tooltip}
            data-testid={`${screenName}_tooltip`}
          >
            {deskTooltip && <span>{deskTooltip}</span>}
          </div>
        </div>
        {mobileTooltip && <span>{mobileTooltip}</span>}
      </Section.Content>
    </Section.Root>
  )
}
